export default "__VITE_ASSET__Cbubjm1a__"